import React from 'react';
import './empty.css';

export const Empty = ({ children }) => {
    return (
        <div id="content">
            <div className="flex">
                <div className="flex-grow">{children}</div>
                <div className="hidden visible-md visible-lg col-md-6 login-right"></div>
            </div>
        </div>
    );
};

export default Empty;
